(ns iris.posts.background
  (:require
   [re-frame.core :as re-frame]
   [iris.globals :as globals]))

(def set-timer-event :iris.posts.events/set-timer)
(def set-post-fb-data-event :iris.posts.events/set-post-fb-data)

;; we do start and stop interval on post load so not sure if checking batch-datetime is necessary
;; but perhaps it is a better method since it doesn't involve starting and stopping interval??
;; NOTE: 04/22/2024 interval is still in use through http get post list. Decided not to take it out at this point
;; run-interval-code with :posts :batch-datetime is therefore not needed (because each post load offsets the execution of interval code)
;; but it could be useful to setup things on a more granular level - perhaps some tasks could be run more earlier/later/more/less frequent
;; based on batch-datetime
;; NOTE: DO NOT DELETE THIS FUNCTION
;; (re-frame/reg-event-fx
;;  ::run-interval-code
;;  (fn [{:keys [db]} [_]]
;;    (println "entering ::run-interval-code")
;;    (let [batch-datetime (get-in db [:posts :batch-datetime])
;;          now-datetime (.now js/Date)]
;;      (println "run-interval-code :: " batch-datetime now-datetime)
;;      (if (> (/ (- now-datetime batch-datetime) 1000) 120)
;;        (do
;;          (println "::run-interval-code :: more than 120 seconds expired since last batch, do set-post-fb-data")
;;          (re-frame/dispatch [::set-timer (.now js/Date)])
;;          (re-frame/dispatch [::set-post-fb-data]))
;;        (println "::run-interval-code :: skipping, not enough time has passed"))
;;      {})))

(def interval-id (atom nil))

(defn interval-code []
  (println "INTERVAL CODE STARTING" (.-visibilityState js/document))
  ;; TODO: set-timer should be set every time the posts are loaded - and
  ;; before running the interval code check that x minutes have passed - currently
  ;; there is too much traffic jam on workers - it's too congested
  ;; with tasks due to interval code + thread alerts running all the time
  ;; another option is not to run the code, or run it less frequently, in case of mobile or if device has < n cores
  ;; yet another option is to call each worker and tell it to stop working, kinda like interval stop
  (when (= (.-visibilityState js/document) "visible")
    (println "INTERVAL will run code")
    (re-frame/dispatch [set-timer-event (.now js/Date)])
    (re-frame/dispatch [set-post-fb-data-event])))

(defn interval-start []
  (when (nil? @interval-id)
    (println "STARTING INTERVAL")
    (reset! interval-id (js/setInterval interval-code 60000))))

(defn interval-end []
  (when (some? @interval-id)
    (println "STOPPING INTERVAL")
    (js/clearInterval @interval-id)
    (reset! interval-id nil)))

(add-watch globals/fb-user :fb-user-interval
           (fn [_key _atom _old-state new-state]
             (when (and (nil? new-state)
                        (some? @interval-id))
               (println "TURNING OFF INTERVAL CODE BECAUSE OF FB_USER")
               (interval-end))))

(re-frame/reg-event-db
 set-timer-event
 (fn [db [_ data]]
   (assoc-in db [:posts :timer] data)))
